import React from 'react';

import { ChevronFullIcon } from '@/assets/icons/chevron-full';
import { useDeviceoutput } from '@/core/features/cookies/use-device-output';
import color from '@/core/features/styles/color';
interface FilterGroupShowMoreProps {
    isExpanded: boolean;
    maxCount: number;
    optionCount: number;
    qaId?: string;
    showAllOptions?: boolean;
    toggleExpanded: () => void;
}

export default function FilterGroupShowMore({
    isExpanded: showMore,
    maxCount,
    optionCount,
    qaId,
    showAllOptions,
    toggleExpanded: setShowMore,
}: FilterGroupShowMoreProps) {
    const { isDesktopView } = useDeviceoutput();

    if (showAllOptions === true || optionCount <= maxCount) {
        return null;
    }

    return (
        <div
            className={'flex justify-end items-center mt-10 text-endeavour cursor-pointer'}
            data-qa-id={qaId}
            onClick={setShowMore}
        >
            <span className={isDesktopView ? 'text-12' : 'text-14'}>{`${showMore ? 'weniger' : 'mehr'} `}anzeigen</span>
            <ChevronFullIcon
                color={color('endeavour')}
                height={10}
                style={{
                    display: isDesktopView ? 'none' : undefined,
                    // eslint-disable-next-line no-inline-styles/no-inline-styles
                    marginLeft: 10,
                    rotate: showMore ? '-90deg' : '90deg',
                }}
                width={7}
            />
        </div>
    );
}
